import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, EventEmitter, Inject, inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';

@Component({
    selector: 'clever-menu2-subitem',
    templateUrl: './menu2-subitem.component.html',
    styleUrls: ['./menu2-subitem.component.scss'],
    standalone: false
})
export class Menu2SubitemComponent implements OnInit {
    @Input() column: any;
    @Input() editmode: boolean;
    @Input() deskmode: string;
    @Output() removecolumn: EventEmitter<boolean> = new EventEmitter<boolean>();
    destroyRef = inject(DestroyRef);
    animationState = 'out';
    isBrowser: boolean = false;

    partner: Partner;

    constructor(
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initPartner();
        }
    }

    async initPartner() {
        this.guardService.getPartner$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((obj) => {
                if (obj?.partnerid?.length > 0) {
                    this.partner = obj;
                }
            });
    }
}
